"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = void 0;
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var copy_1 = require("../../copy");
var NextMeterRead = function (_a) {
    var nextReadingDateFormatted = _a.nextReadingDateFormatted;
    var _b = (0, core_1.useComponents)(), Heading4 = _b.Heading4, SummaryList = _b.SummaryList, SummaryItem = _b.SummaryItem;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(SummaryList, null,
        react_1.default.createElement(SummaryItem, { label: react_1.default.createElement(Copy, { copyKey: "meterReadsNextRead" }) },
            react_1.default.createElement(Heading4, { as: "div" }, nextReadingDateFormatted))));
};
var Content = function (_a) {
    var meterInfo = _a.meterInfo;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var lastReadingDateFormatted = (0, date_fns_1.format)(meterInfo.lastReadingDate, 'dd MMM yyyy');
    var nextReadingDateFormatted = (0, date_fns_1.format)(meterInfo.nextReadingDate, 'dd MMM yyyy');
    if (meterInfo.meterType === 'traditional') {
        switch (meterInfo.status) {
            case 'ok': {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Copy, { copyKey: "meterReadsStatusOk" }),
                    meterInfo.reason !== 'isDueButReceived' ? (react_1.default.createElement(NextMeterRead, { nextReadingDateFormatted: nextReadingDateFormatted })) : null,
                    react_1.default.createElement(Copy, { copyKey: "meterReadsLastRead", values: { lastReadingDateFormatted: lastReadingDateFormatted } })));
            }
            case 'due': {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Copy, { copyKey: "meterReadsStatusDue" }),
                    react_1.default.createElement(NextMeterRead, { nextReadingDateFormatted: nextReadingDateFormatted }),
                    react_1.default.createElement(Copy, { copyKey: "meterReadsLastRead", values: { lastReadingDateFormatted: lastReadingDateFormatted } })));
            }
            case 'warning': {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Copy, { copyKey: "meterReadsStatusWarning" }),
                    react_1.default.createElement(Copy, { copyKey: "meterReadsLastRead", values: { lastReadingDateFormatted: lastReadingDateFormatted } })));
            }
        }
    }
    if (meterInfo.meterType === 'smart') {
        switch (meterInfo.status) {
            case 'ok': {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    meterInfo.reason && meterInfo.reason === 'recentManual' ? (react_1.default.createElement(Copy, { copyKey: "meterReadsStatusSmartOkWithManualRead" })) : (react_1.default.createElement(Copy, { copyKey: "meterReadsStatusSmartOk" })),
                    react_1.default.createElement(Copy, { copyKey: "meterReadsLastRead", values: { lastReadingDateFormatted: lastReadingDateFormatted } })));
            }
            case 'warning': {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(Copy, { copyKey: "meterReadsStatusSmartWarning" }),
                    react_1.default.createElement(Copy, { copyKey: "meterReadsLastRead", values: { lastReadingDateFormatted: lastReadingDateFormatted } })));
            }
        }
    }
    return null;
};
exports.Content = Content;
